import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=5f79848a&scoped=true&"
import script from "./CookiePolicy.vue?vue&type=script&lang=ts&"
export * from "./CookiePolicy.vue?vue&type=script&lang=ts&"
import style0 from "./CookiePolicy.vue?vue&type=style&index=0&id=5f79848a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f79848a",
  null
  
)

export default component.exports